import * as Sentry from "@sentry/react";
import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import styles from "./ErrorBoundary.module.css";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  private handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className={styles.container}>
          <h1 className={styles.title}>エラーが発生しました</h1>
          <p className={styles.message}>
            予期しないエラーが発生しました。ページを再読み込みしてください。
          </p>
          <button type="button" className={styles.reloadButton} onClick={this.handleReload}>
            再読み込み
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
